import React from 'react'
import { css, useTheme } from '@emotion/react'
import { MediaQuery } from './Utility'

function ButtonGroup({ children, backgroundColor, color }) {
    const theme = useTheme()
    const borderRadius = theme.borderRadius.default
    return (
        <div
            css={css`
                display: flex;
                background-color: ${theme.colors.dark};
                border-radius: ${borderRadius};
                padding: 0.25rem;
                button {
                    border-radius: 0;
                    background-color: ${theme.colors[backgroundColor]};
                    color: ${theme.colors[color]};
                }

                button:last-child {
                    border-top-left-radius: ${borderRadius};
                    border-bottom-left-radius: ${borderRadius};
                }

                button:first-of-type {
                    border-top-right-radius: ${borderRadius};
                    border-bottom-right-radius: ${borderRadius};
                }

                ${MediaQuery('md', 'max')} {
                    flex-wrap: wrap;
                    justify-content: center;
                    button {
                        border: 0.125rem solid transparent;
                        border-radius: ${borderRadius};
                    }
                }
            `}
            className="button-group"
        >
            {children}
        </div>
    )
}

export default ButtonGroup
